module.exports = __webpack_public_path__ + "img/manlogo.d438ea92.png";